;(function (global) {
    define('core/obj', ['lib/underscore'], function (_) {
        var reservedNames = ['constructor', 'prototype', 'super', 'base', '__proto__', '__super__', '__base__'];

        function JsObject() {
            // NOTE: make this constructor function callable as a factory, i.e.
            // var x = JsObject();
            // instead of requiring
            // var x = new JsObject();
            if (this === global) {
                return new JsObject();
            }
        }

        function extend(instanceDecorator, /* optional */superOptions, /* optional */classDecorator) {
            var argType = { };
            var Superclass = this;
            var Subclass = function (options) {
                var obj;
                var decoration;
                var initializer;

                if (this === global) {
                    return new Subclass(options);
                }

                obj = this;
                if (argType['instanceDecorator'] === 'function') {
                    // NOTE: since a function was used to declare the Subclass' methods and properties,
                    // it's possible that these have access to private information (hidden inside the function) -
                    // afterall, *this* is the reason to use a decorator function insted of a decoration;
                    // hence, we need to attach them directly to the object and not to the prototype,
                    // otherwise the private state will be shared across all instances of Subclass,
                    // making it, in effect, "private static" data (there are other ways to declare such information)
                    decoration = instanceDecorator.call();
                    if (isPojo(decoration)) {
                        // NOTE: we need to decorate the object in a top-down manner,
                        // so that, by the time the initializer is called, all the methods and overrides are available
                        // (by the way, using prototypal inheritance optimization will naturally behave similarly)
                        _.defaults(obj, _.omit(decoration, reservedNames));
                        initializer = decoration.init;
                    }
                } else if (argType['instanceDecorator'] === 'object') {
                    decoration = instanceDecorator;
                    // TODO: optimize this code path by using prototypal inheritance
                    _.defaults(obj, _.omit(decoration, reservedNames));
                    initializer = decoration.init;
                }

                Superclass.call(obj, argType['superOptions'] === 'function' ? superOptions.call(null, options) : options);

                // TODO: how to reliably emulate "super" functionality?
                if (_.isFunction(initializer)) {
                    initializer.call(obj, options);
                }

                return obj;
            };

            argType['instanceDecorator'] = getType(instanceDecorator);
            argType['superOptions'] = getType(superOptions);
            if (argType['superOptions'] === 'object') {
                // NOTE: superOptions is an optional function parameter;
                // if the 2nd parameter looks like an object instead, assume it's actually the classDecorator
                classDecorator = superOptions;
                superOptions = undefined;

                argType['superOptions'] = undefined;
            }

            argType['classDecorator'] = getType(classDecorator);

            _.extend(Subclass, Superclass);
            if (argType['classDecorator'] === 'object') {
                _.extend(Subclass, _.omit(classDecorator, reservedNames));
            }

            return Subclass;

            function getType(value) {
                if (value != null) {
                    if (_.isFunction(value)) {
                        return 'function';
                    } else if (_.isArray(value)) {
                        return 'array';
                    } else if (_.isObject(value)) {
                        return 'object';
                    }
                }
            }
        }

        function aliasFor(method) {
            // TODO: optimize during type extension stage - make the aliases really reference the aliased method
            return function () {
                var aliasedMethod = this[method];
                if (_.isFunction(aliasedMethod)) {
                    return aliasedMethod.apply(this, arguments);
                }
            };
        }

        /**
         * A.k.a "Is Plain-Old-JavaScript-Object".
         * Underscore's isObject() method returns true for functions and arrays, too, so we need to filter them out.
         */
        function isPojo(obj) {
            return _.isObject(obj) && !_.isArray(obj) && !_.isFunction(obj);
        }

        JsObject.extend = extend;
        JsObject.aliasFor = aliasFor;
        return JsObject;
    });
})(this);
